import { FormattedMessage } from "react-intl";
import { MenuItem } from "react-bootstrap";
import { intlShape } from "../../shapes";
import { apiShape, notifierShape, withApi, withNotifier } from "../../context";
import { BadRequestError, PaymentRequiredError } from "../../api";
import { withIntl } from "../../wrappers";
import { useSubscriptionQuery } from "../../hooks";

type Props = {
  api: apiShape;
  assign: boolean;
  intl: intlShape;
  id?: number;
  type?: string;
  notifier?: notifierShape;
};

export function SubscriptionAssignmentMenuItem({
  api,
  intl,
  assign,
  id,
  type,
  notifier,
}: Props) {
  const { data: subscription } = useSubscriptionQuery();
  const handleOnSubscriptionAssign = async () => {
    try {
      // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
      await api.post(`/subscriptions/${subscription.id}/asset_assignment`, {
        object_id: id,
        object_type: type,
      });
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      notifier.showSuccess(
        intl.formatMessage({ id: "asset_assignment.assign_success" }),
      );
    } catch (error) {
      if (
        error instanceof BadRequestError &&
        error.contains("empty_asset_list")
      ) {
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        notifier.showError(
          intl.formatMessage({ id: "api.error.empty_asset_list" }),
        );
      } else if (
        error instanceof PaymentRequiredError &&
        error.contains("quota_exceeded")
      ) {
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        notifier.showError(
          intl.formatMessage({ id: "api.error.quota_exceeded" }),
        );
      } else {
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        notifier.showError(intl.formatMessage({ id: "api.error.unknown" }));
      }
    }
  };

  const handleOnSubscriptionUnassign = async () => {
    try {
      // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
      await api.delete(`/subscriptions/${subscription.id}/asset_assignment`, {
        object_id: id,
        object_type: type,
      });
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      notifier.showSuccess(
        intl.formatMessage({ id: "asset_assignment.unassign_success" }),
      );
    } catch (error) {
      if (
        error instanceof BadRequestError &&
        error.contains("empty_asset_list")
      ) {
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        notifier.showError(
          intl.formatMessage({ id: "api.error.empty_asset_list" }),
        );
      } else {
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        notifier.showError(intl.formatMessage({ id: "api.error.unknown" }));
      }
    }
  };

  if (subscription) {
    if (assign) {
      return (
        <MenuItem
          id="item-subscription-assign"
          onSelect={handleOnSubscriptionAssign}
        >
          <FormattedMessage id="button.assign_assets_to_subscription" />
        </MenuItem>
      );
    }
    return (
      <MenuItem
        id="item-subscription-unassign"
        onSelect={handleOnSubscriptionUnassign}
      >
        <FormattedMessage id="button.unassign_assets_to_subscription" />
      </MenuItem>
    );
  }
  return null;
}

// @ts-expect-error TS(2345) FIXME: Argument of type '{ (props: Readonly<Omit<Props, "... Remove this comment to see the full error message
export default withIntl(withNotifier(withApi(SubscriptionAssignmentMenuItem)));
